
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { NepaliDatePicker } from "nepali-datepicker-reactjs"
import "nepali-datepicker-reactjs/dist/index.css"
import { convertDateToAD, convertDateToBS } from '../utils/convertDate'
import { formatDateInBS } from '../utils/formatDate'
import apiConnector from '../utils/axios'
import URL from '../constants/ServerUrl'
import axios from 'axios'

const CollectionReport = ({route}) => {
  // FOR DATE PICKER
  const [startDate, setStartDate] = useState(convertDateToBS(Date.now() - 30 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(convertDateToBS(Date.now()))
  
  const [tableData, setTableData] = useState([])
  const [userData, setUserData] = useState([])
  const [username, setUsername] = useState('No User')
  const [shift, setShift] = useState("Both")
  const [loading, setLoading] = useState(false)
  const [focus, setFocus] = useState(false)

  // FOR SEARCH BOX
  const [search, setSearch] = useState('')

  const [filteredTableData, setFilteredTableData] = useState([])

  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [prevStartDate, setPrevStartDate] = useState(startDate);
  const [prevEndDate, setPrevEndDate] = useState(endDate);
  const [prevShift, setPrevShift] = useState(shift);
  const token = localStorage.getItem("dairy-token")

  // Create a debounce function
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        func.apply(context, args);
      }, delay);
    };
  };

  // Function to handle search changes after debouncing
  const handleSearchDebounced = useCallback(
    debounce((searchValue) => {
      setDebouncedSearch(searchValue);
      if (searchValue === '') {
        setUsername("No User");
      }
    }, 300), // Adjust the debounce delay as needed
    []
  );

  // Trigger API requests when debouncedSearch changes
  useEffect(() => {
    handleSearchDebounced(search); // Update the debounced value
  }, [search, handleSearchDebounced]);

  // FOR TABLE
  const tableHead = useMemo(() => [
    { label: 'Shift', flex: 'flex-2' },
    { label: 'Date', flex: 'flex-5' },
    { label: 'Qty', flex: 'flex-3' },
    { label: 'Fat', flex: 'flex-3' },
    { label: 'Snf', flex: 'flex-3' },
    { label: 'Amount', flex: 'flex-4' },
], []);


  const fetchAllUsers = async () => {
    try {
      
      const res = await axios.get( `${URL}user`, {}, {
        Authorization: `Bearer ${token}`,
      })
      console.log(res);
      setUserData(res.data)

    }
    catch(err)
    {
      console.log(err)
    }
  }

  const fetchUserCollections = async () => {
    if (!username || username === "No User")
    {
      return
    }
    try {
      setLoading(true)
      let start = convertDateToAD(startDate)
      let end = convertDateToAD(endDate)

      const res = await apiConnector("GET",
      `admin/collection/report?startDate=${start}&endDate=${end}&shift=${shift}`,
      {},
      {
        Authorization: `Bearer ${token}`,
      }
      )

      const collectionArray = res.data.map((collection) => {
        return [
          collection?.userId,
          collection?.username,
          collection?.shift === "Morning" ? "M" : "E",
          formatDateInBS(collection.date),
          collection?.totalMilk.toFixed(2),
          collection?.avgFat.toFixed(2),
          collection?.avgSNF.toFixed(2),
          collection?.totalAmount.toFixed(2),
        ]
      })
      
      setTableData(collectionArray)
      setLoading(false)
    }
    catch(err)
    {
      setLoading(false)
      console.log(err)
    }
  }
  useEffect(() => {
    fetchAllUsers()
    fetchUserCollections()
  }, [])

  useEffect(() => {
    // Define a flag to check if any of the relevant state values have changed
    const shouldFetchData =
      debouncedSearch !== search ||
      startDate !== prevStartDate ||
      endDate !== prevEndDate ||
      shift !== prevShift;
  
    if (shouldFetchData) {
      // Update the previous state values
      setPrevStartDate(startDate);
      setPrevEndDate(endDate);
      setPrevShift(shift);
  
      // Make the API request only if necessary
      fetchUserCollections();
    }
  }, [debouncedSearch, startDate, endDate, shift, search, prevStartDate, prevEndDate, prevShift]);
  

useEffect(() => {
    if (username != null) {
      setFilteredTableData(tableData.filter((row) => row[1] === username))
    }
  }, [username, tableData])


  const onChangeStart = ( date) => {
    setStartDate(date)
  }

  const onChangeEnd = ( date) => {
    setEndDate(date)
  }


  return (
    <div className="p-4 bg-green-50">
    <input
      className="w-full p-2 border rounded-md focus:outline-none focus:border-blue-500"
      placeholder="Search by name"
      onChange={(e) => {
        setSearch(e.target.value);
        handleSearchDebounced(e.target.value);
        if (e.target.value === '') {
          setUsername(null);
        }
      }}
      onFocus={() => setFocus(true)}
      value={search}
    />

    {focus && (
      <div className="space-y-4">
        {search !== '' &&
          userData
            .filter(({ username, userId }) => {
              if (!isNaN(parseFloat(search))) return search == userId;
              return username.toLowerCase().startsWith(search.toLowerCase());
            })
            .map((item) => (
              <div
                key={item.userId}
                onClick={() => {
                  setUsername(item.username);
                  setSearch(item.username);
                  setFocus(false);
                }}
                className="cursor-pointer border p-4 rounded-md hover:bg-gray-100"
              >
                <div>{item.userId}</div>
                <div>{item.username}</div>
              </div>
            ))}
      </div>
    )}

    {!focus && (
      <>
        <div className="flex flex-row w-full">
          <div className="flex flex-col w-1/2">
            <p>From</p>
            <form className="cursor-pointer">
              <NepaliDatePicker
                inputClassName="form-control"
                className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                value={startDate}
                onChange={onChangeStart}
                options={{ calenderLocale: 'en', valueLocale: 'en' }}
              />
            </form>
          </div>

          <div className="flex flex-col w-1/2">
            <p>To</p>
            <form className="cursor-pointer">
              <NepaliDatePicker
                inputClassName="form-control"
                className="form-control border rounded-md p-2 focus:outline-none focus:border-blue-500"
                value={endDate}
                onChange={onChangeEnd}
                options={{ calenderLocale: 'en', valueLocale: 'en' }}
              />
            </form>
          </div>
        </div>

        <div>
          <div>{username}</div>
        </div>

        {loading && (
          <div>
            <div>Fetching Collections...</div>
          </div>
        )}

        {!loading && search === '' && (
          <div>
            <div>Please Search by Id</div>
          </div>
        )}

        {/* Other conditional rendering based on loading and search */}
        
        {!loading && search !== '' && filteredTableData.length > 0 && (
          <div className="my-5">
            <table className="w-full">
              <tbody>
                <tr>
                  {tableHead.map((header, index) => (
                    <td
                      key={index}
                      className={`border px-4 py-2 font-semibold flex-${tableHead[index].flex}`}
                    >
                      {header.label}
                    </td>
                  ))}
                </tr>
                {filteredTableData.map((rowData, index) => (
                  <tr key={index} className="border-b">
                    {rowData.slice(2).map((dataItem, dataIndex) => (
                      <td key={dataIndex} className="border px-4 py-2">
                        {dataItem}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </>
    )}
  </div>
  
  )
}

export default CollectionReport;